module.exports = __webpack_public_path__ + "static/media/RHS75P.b17a989f.jpg";